import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var NewsService = /** @class */ (function () {
    function NewsService(http) {
        this.http = http;
        this.checkMonth = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
    }
    NewsService.prototype.getLatestNews = function (newsPeriod) {
        var _latestNewsUrl = cmsApi + '/get_newsList_topX';
        var _latestNewsBody = { top: '3', month: newsPeriod };
        // console.log(_latestNewsBody);
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    NewsService.prototype.getLatestNews_2 = function (newsPeriod) {
        var _latestNewsUrl = cmsApi + '/get_newsList_topX_2';
        var _latestNewsBody = { top: '3', month: newsPeriod };
        // console.log(_latestNewsBody);
        return this.http.post(_latestNewsUrl, _latestNewsBody);
    };
    NewsService.prototype.getSpecificNewsFromId = function (newsId) {
        var _specificNewsUrl = cmsApi + '/get_newsById';
        var _specificNewsBody = { newsid: newsId };
        return this.http.post(_specificNewsUrl, _specificNewsBody);
    };
    NewsService.prototype.getNewsFromPeriod = function (newsPeriod) {
        var _getNewsPeriodUrl = cmsApi + '/get_newsList_topM';
        var _getNewsPeriodBody = { month: newsPeriod };
        // console.log(_getNewsPeriodBody)
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    NewsService.prototype.changeFormatDate = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_1 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_1; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    NewsService.prototype.date_thai = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (day + ' ' + monthTh['name'] + ' ' + year);
    };
    NewsService.prototype.date_thai_dd = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (day);
    };
    NewsService.prototype.date_thai_mm = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (monthTh['name']);
    };
    NewsService.prototype.date_thai_yy = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] == month; })[0];
        return (year);
    };
    NewsService.prototype.changeFormatDate_dd = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_2 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_2; })[0];
            return day;
        }
    };
    NewsService.prototype.changeFormatDate_MM = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_3 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_3; })[0];
            return monthTh['name'];
        }
    };
    NewsService.prototype.changeFormatDate_yy = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_4 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_4; })[0];
            return year;
        }
    };
    NewsService.prototype.get_announceList = function (isActive) {
        var _getNewsPeriodUrl = cmsApi + '/get_announceList/';
        var _getNewsPeriodBody = { IsActive: isActive,
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    NewsService.prototype.get_eartUpdateList = function (isActive) {
        var _getNewsPeriodUrl = cmsApi + '/get_earthupdateList/';
        var _getNewsPeriodBody = { IsActive: isActive,
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    NewsService.ngInjectableDef = i0.defineInjectable({ factory: function NewsService_Factory() { return new NewsService(i0.inject(i1.HttpClient)); }, token: NewsService, providedIn: "root" });
    return NewsService;
}());
export { NewsService };
